module.exports = __webpack_public_path__ + "img/policies.ae79486d.svg";